module.exports = [{"chars":["h","m","w","р","ь","ц"],"tool":"HandTool"},{"chars":[".","ю"],"tool":"PointTool"},{"chars":["i","/","|","\\","ш"],"tool":"LineTool"},{"chars":["o","0","щ"],"tool":"CircleTool"},{"chars":["t","+","е"],"tool":"PBisectTool"},{"chars":["l","д"],"tool":"PerpTool"},{"chars":["a","ф"],"tool":"ABisectTool"},{"chars":["z","n","=","я","т"],"tool":"ParallelTool"},{"chars":["q","й"],"tool":"CompassTool"},{"chars":["x","ч"],"tool":"IntersectTool"}]


//////////////////
// WEBPACK FOOTER
// ./src/resources/localizable/toolKeys.json
// module id = 1333
// module chunks = 0